import React from "react";
import Header from "../Landingpagecomponents/Header/header"
import { Grid, Typography } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import Footer from "../Landingpagecomponents/Footer/Footer"
import BackToTop from "./policy_scroll";


const Privacy_Healthdata_policy = () => {
    return (
    <Grid container xs={12} style={{backgroundColor: "#eaeaea"}}>
        <Header/>
        <Grid xs={12} style={{backgroundColor: "#002D55", height: 250}} />
        <Grid container justify="center" style={{backgroundColor: "#eaeaea", marginTop: 20}}>
            <Paper item xs={12}  style={{width: "70%", margin: 20, padding: 20}}>
                <Typography style={{justify: "center", justifyContent: "center", alignText: "center", backgroundColor: "#FFFFFF", color: "#002D55"}}>
                    <h1>We Comply with The General Data Protection Regulation (GDPR)</h1>
                    <p>At VirtusPhysio we believe in handling your data with virtue and with the highest of standards. <br /><br />
                    Therefore our Privacy Policy is in full concordance with The General Data Protection Regulation (GDPR), and you can read the details about our Privacy Policy in the FAQ below. <br /><br />
                    We want to build a relationship of trust & transparency between us and our clients. <br /><br />
                    A relationship where you can trust the quality and efficiency of our personalised programs and where you can feel safe and secure about what types of data and information that you allow us to collect from you while using our virtual healthcare service, after accepting our Terms & Conditions.<br /><br />
                    We've tried to make our Privacy Policy as clear and transparent to our customers and clients as possible by outlined them in the FAQ below in a structured and manageable way under themes.<br /><br />
                    To read each part of our privacy policy simply click each headline and the text will expand.<br /><br />
                    If you have any questions that is not answered in the FAQ below, you are most welcome to contact our customer service at info@virtusphysio.com <br /><br />
                    </p>
                </Typography>
            </Paper>
            <Grid xs={12}/>
            <Paper item xs={12} style={{width: "70%", justify: "center", margin: 20, padding: 20}}>
                <Typography style={{color: "#002D55"}}>
                    <h1>Our Privacy & Healthdata Policy</h1>
                    <h2 style={{color: "#002D55"}}>Our role and duty as healthcare provider</h2>
                    <p>
                    Your personal health data will be handled in accordance with EU's General Data Protection Regulation (GDPR). As healthcare professionals we are in most cases further required by law to store your healthdata in a journal for 5 years.
                    You can at any time request a report of the journal that is created by your answers, or the data we store on you. If any data is incorrect you can request to have it deleted or changed.
                    We will ask you to answer as correctly and thruthfully as possible on each question, and remind you that providing false information in medical records is illegal. We are required to be cabable to identify all of our patients who completed the virtual consultation, and will therefore ask for personal information that can identify you.
                    By continuing you also accept and acknowledge that the precision of our diagnosis and treatment plan depends on your ability to answer the questions correctly and that we cannot be held legally responsible for any misunderstood or wrongfully answered question, nor any inprecise diagnosis or treatment advice. By continuing you acknowledge that you are not using this virtual solution for any emergency or as a substitute for a doctor or hospital visit and that you present yourself with no life-threatening symptoms and that by using this service you consider it solely as an alternative to seeking treatment at your regular physiotherapist clinic.
                    It is not allowed to answer for someone else as this increases the likelihood of imprecise answers and could in worst case put the health of the individual at risk. Nor is it allowed to answer pretending to be someone else (real or fictive) and this will be considered as identity fraud or as an attempt of acting in bad faith with intent to deceive and will be lawfully dealt with accordingly.
                    Your data is collected by a third party service provider: "Typeform" who is restricted from any further data handling. We will solely use the data we gather from your answers to find the right treatment plan for you, which will be accessible on app, tablet or PC through a third party service provider: "PhysiApp".
                    </p>
                    <h2 style={{color: "#002D55"}}>Information we may collect about you</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Uses made of the information</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Other uses of information we collect about you</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Other uses of information we receive from other sources</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Service providers</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Access to information</h2>
                    <p>
                        text
                    </p>
                    <h2 style={{color: "#002D55"}}>Changes to our privacy policy</h2>
                    <p>
                        text
                    </p>
                </Typography>
            </Paper>
        </Grid>
    <Grid xs={12} container justify="center" justifyContent="center">
        <Footer />
    </Grid>
    </Grid>
    );
};

export default Privacy_Healthdata_policy;

